import React, { useState } from "react";
import { Share } from "@material-ui/icons";
import L from "leaflet";
import { MapContainer, Marker, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";

import { Styles } from "./style/locationMapStyle";

const latitude = Number(process.env.REACT_APP_EXCHANGE_LATITUDE);
const longitude = Number(process.env.REACT_APP_EXCHANGE_LONGITUDE);
const hasLocation = Number.isFinite(latitude) && Number.isFinite(longitude);

const markerIcon = L.divIcon({
  className: "exchange-map-marker",
  html: '<span class="exchange-map-marker-dot"></span>',
  iconSize: [30, 30],
  iconAnchor: [15, 30],
});

const navigationApps = hasLocation
  ? [
      {
        id: "neshan",
        name: "نشان",
        icon: "/image/map/neshan.png",
        url: `https://nshn.ir/?lat=${latitude}&lng=${longitude}`,
      },
      {
        id: "balad",
        name: "بلد",
        icon: "/image/map/balad.png",
        url: `https://balad.ir/location?latitude=${latitude}&longitude=${longitude}`,
      },
      {
        id: "google-maps",
        name: "گوگل مپ",
        icon: "/image/map/google-map.png",
        url: `https://maps.google.com/maps?q=${latitude},${longitude}`,
      },
      {
        id: "waze",
        name: "ویز",
        icon: "/image/map/waze.png",
        url: `https://www.waze.com/ul?ll=${latitude},${longitude}&navigate=yes`,
      },
    ]
  : [];

const LocationMap = () => {
  const [copiedMap, setCopiedMap] = useState("");
  const [isMapUnlocked, setIsMapUnlocked] = useState(false);

  const shareNavigation = async (app) => {
    const shareData = {
      title: "مسیریابی صرافی اسدزاده",
      text: `مسیریابی صرافی اسدزاده با ${app.name}`,
      url: app.url,
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
        return;
      }

      await navigator.clipboard.writeText(app.url);
      setCopiedMap(app.id);
      window.setTimeout(() => setCopiedMap(""), 2000);
    } catch (shareError) {
      if (shareError?.name !== "AbortError") {
        setCopiedMap("");
      }
    }
  };

  if (!hasLocation) {
    return null;
  }

  return (
    <Styles>
      <section className="location-section" aria-labelledby="location-title">
        <div className="location-header">
          <div>
            <div className="location-label" id="location-title">موقعیت مکانی روی نقشه</div>
          </div>
          <p>برای مشاهده مسیر، اپلیکیشن مسیریاب مورد نظر خود را انتخاب کنید.</p>
        </div>

        <div className={`map-frame${isMapUnlocked ? " unlocked" : ""}`}>
          <MapContainer
            key={isMapUnlocked ? "unlocked" : "locked"}
            center={[latitude, longitude]}
            zoom={14}
            scrollWheelZoom={isMapUnlocked}
            dragging={isMapUnlocked}
            touchZoom={isMapUnlocked}
            doubleClickZoom={isMapUnlocked}
            boxZoom={isMapUnlocked}
            keyboard={isMapUnlocked}
            className="map"
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>'
              url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
            />
            <Marker position={[latitude, longitude]} icon={markerIcon} />
          </MapContainer>
          {!isMapUnlocked && (
            <button
              type="button"
              className="map-lock"
              onClick={() => setIsMapUnlocked(true)}
              aria-label="فعال کردن نقشه"
            >
              برای فعال کردن نقشه کلیک کنید
            </button>
          )}
        </div>

        <div className="navigation-apps">
          {navigationApps.map((app) => (
            <div className="navigation-card" key={app.id}>
              <a href={app.url} target="_blank" rel="nofollow noreferrer">
                <img src={app.icon} width="32" height="32" alt={`مسیریابی با ${app.name}`} />
                <span>{app.name}</span>
              </a>
              <button
                type="button"
                onClick={() => shareNavigation(app)}
                aria-label={`ارسال لینک مسیریابی ${app.name}`}
              >
                <Share className="share-icon" />
                <span>{copiedMap === app.id ? "کپی شد" : "ارسال"}</span>
              </button>
            </div>
          ))}
        </div>
      </section>
    </Styles>
  );
};

export default LocationMap;
